import { data } from '../../svg/Consent/data';
import { makeIcon } from '../makeIcon';

export const Consent = makeIcon(data, 'consent', 'Consent');

export default Consent;
